import { useState } from "react";

import { toISODateTime } from "common/utils/dates";
import { UserSubscriptionAction } from "common/types";

import { useUpdateSubscriptionMutation } from "client/subscriptions/hooks";
import Calendar from "client/common/components/calendars/Calendar";
import FetchErrorAlert from "client/common/components/errors/FetchErrorAlert";
import { useInvalidateOnboarding } from "client/onboarding/hooks/invalidate";
import Modal from "client/common/components/deprecated-modals/Modal";
import ModalLayout from "client/common/components/deprecated-modals/ModalLayout";
import SubscriptionDateBanners from "client/subscriptions/components/SubscriptionDateBanners";

type UpdateNextOrderDateModalProps = {
  isVisible: boolean;
  onClose: () => void;
  subscriptionId: number;
  initialNextOrderDate: string;
};

const UpdateNextOrderDateModal = ({
  isVisible,
  onClose,
  subscriptionId,
  initialNextOrderDate,
}: UpdateNextOrderDateModalProps) => {
  const invalidateOnboarding = useInvalidateOnboarding();
  const {
    mutate: updateSubscription,
    isLoading: isUpdating,
    error: updateError,
  } = useUpdateSubscriptionMutation(subscriptionId, {
    onSuccess: () => {
      invalidateOnboarding();
      onClose();
    },
  });
  const [nextOrderDate, setNextOrderDate] = useState(new Date(initialNextOrderDate));

  const onSubmit = () => {
    updateSubscription({
      action: UserSubscriptionAction.Modify,
      next_order_date: toISODateTime(nextOrderDate),
    });
  };

  return (
    <Modal visible={isVisible} onClose={onClose}>
      <ModalLayout>
        <ModalLayout.Header title="Update next order date" onClose={onClose} />
        {!!updateError && (
          <FetchErrorAlert error={updateError} fieldErrors={[updateError.errors.next_order_date]} />
        )}
        <ModalLayout.Form
          isLoading={isUpdating}
          canSubmit={true}
          submitText="Update order date"
          onSubmit={onSubmit}
          size="l"
        >
          <Calendar
            disabledDays={{ before: new Date() }}
            selectedDays={nextOrderDate}
            onSelect={setNextOrderDate}
          />
          <SubscriptionDateBanners dates={[nextOrderDate]} />
        </ModalLayout.Form>
      </ModalLayout>
    </Modal>
  );
};

export default UpdateNextOrderDateModal;
